import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {updateDocumentTitle} from "../../Utils/Common";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, Tabs, DataTable} from "../UI";

const RidersList = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [activeList, setActiveList] = useState([]);
    const [inactiveList, setInactiveList] = useState([]);
    const [tab, setTab] = useState("active");
    const columns = [
        {
            name: 'Name',
            selector: 'name',
            sortable: true,
            cell: row => <div><Link to={"/riders/" + row.id}>{row.name}</Link></div>,
        },
        {
            name: 'Phone',
            selector: 'phone',
        },
        {
            name: 'Email',
            selector: 'email',
        },
        {
            name: 'ID Number',
            selector: 'id_number',
        }
    ]

    const load = (loadMore, status) => {
        let data = new FormData();
        data.append("status", status);
        setIsLoading(true);
        postData(Endpoints.RIDER_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (status === 0) {
                    let currentPosts = loadMore ? activeList : [];
                    currentPosts = currentPosts.concat(...res.data);
                    setActiveList(currentPosts);
                }

                if (status === 1) {
                    let currentPosts = loadMore ? inactiveList : [];
                    currentPosts = currentPosts.concat(...res.data);
                    setInactiveList(currentPosts);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        updateDocumentTitle("Riders")
        load(false, 1);
        load(false, 0);
    }, []);

    return (
        <PageLayout
            title="Riders"
            actions={
                <Link to="/riders/new">
                    <Button>Add new rider</Button>
                </Link>
            }
        >
            <Tabs
                tabs={[
                    {key: "active", label: "Active", count: inactiveList.length},
                    {key: "inactive", label: "Inactive", count: activeList.length},
                ]}
                value={tab}
                onChange={setTab}
            />

            <Card padded={false}>
                {tab === "active" &&
                <DataTable
                    columns={columns}
                    data={inactiveList}
                    progressPending={isLoading}
                    pointerOnHover={true}
                    noHeader={true}
                    onRowClicked={e => {
                        history.push('/riders/' + e.id);
                    }}
                />
                }
                {tab === "inactive" &&
                <DataTable
                    columns={columns}
                    data={activeList}
                    progressPending={isLoading}
                    pointerOnHover={true}
                    noHeader={true}
                    onRowClicked={e => {
                        history.push('/riders/' + e.id);
                    }}
                />
                }
            </Card>
        </PageLayout>
    )
};

export default RidersList;
